"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const DatahubAIContentTypes_1 = require("./DatahubAIContentTypes");
class DatahubAIContentService {
}
DatahubAIContentService.sendOpen = () => {
    DatahubAIContentService.sendInteractionClickEvent(DatahubAIContentTypes_1.AIContentCategory.OpenAIContent);
};
DatahubAIContentService.sendClose = (actionClose) => {
    DatahubAIContentService.sendInteractionClickEvent(DatahubAIContentTypes_1.AIContentCategory.CloseAIContent, actionClose);
};
DatahubAIContentService.sendGenerateStructure = (subject) => {
    DatahubAIContentService.sendInteractionClickEvent(DatahubAIContentTypes_1.AIContentCategory.GenerateAIContent, subject);
};
DatahubAIContentService.sendAddStructure = ({ totalSelectedModules, totalSelectedPages }) => {
    const label = `total of selected modules/pages: ${totalSelectedModules}/${totalSelectedPages}`;
    DatahubAIContentService.sendInteractionClickEvent(DatahubAIContentTypes_1.AIContentCategory.AddAIContent, label);
};
DatahubAIContentService.sendDiscardStructure = () => {
    DatahubAIContentService.sendInteractionClickEvent(DatahubAIContentTypes_1.AIContentCategory.DiscardAIContent);
};
DatahubAIContentService.sendInteractionClickEvent = (category, label = '') => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category,
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            label
        })
    });
};
exports.default = DatahubAIContentService;
